export default {
  els: document.querySelectorAll('.js-3d-image'),
  init() {
    if (!this.els.length) return;

    this.els.forEach((el) => {
      el.style.perspective = '75rem';
    });

    document.addEventListener('scroll', () => {
      this.update();
    });

    this.update();
  },
  update() {
    const screenHeight = window.innerHeight;

    this.els.forEach((el) => {
      const rect = el.getBoundingClientRect();
      const top = rect.top;
      const bottom = rect.bottom;
      const center = rect.top + rect.height / 2;

      if (top < window.innerHeight && bottom >= 0) {
        el.classList.add('in-view');

        const delta = (1 - center / screenHeight) * 2;
        el.children[0].style.transform = `
            rotateY(${
              (delta + 0.75) * (el.dataset.right === '1' ? -15 : 15)
            }deg)
            `;
      } else {
        el.classList.remove('in-view');
      }
    });
  },
};
